import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { 
    AssociateUser, 
    DissociateUser, 
    ExtendAssociation, 
    DeviceSessionsList,
    SearchDeviceSessions,
    AssociateOrDissociateUser
} from "../models/device-sessions";


@Injectable({
    providedIn: 'root'
})

export class DeviceSessionsService {

    user: string;
    userName: string;

    constructor(private http: HttpClient) {
        this.user = sessionStorage.getItem('user');
        this.userName = JSON.parse(this.user).username;
     }

    associate(payload: AssociateOrDissociateUser) {
        const sessionId = localStorage.getItem('sessionId');
        const url = `${environment.apiURL}/admin/devices/associate-device`;
        const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`)
        return this.http.post<AssociateOrDissociateUser>(url, payload, {headers});
    }

    dissociate(payload: AssociateOrDissociateUser) {
        const sessionId = localStorage.getItem('sessionId');
        const url = `${environment.apiURL}/admin/devices/dissociate-device`;
        const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`)
        return this.http.post<AssociateOrDissociateUser>(url, payload, {headers});
    }

    extend(payload: ExtendAssociation) {
        const sessionId = localStorage.getItem('sessionId');
        const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`);
        const url = `${environment.apiURL}/admin/devices/extend`;
        return this.http.post<ExtendAssociation>(url, payload, { headers });
    }

    search(payload: SearchDeviceSessions) {
        const sessionId = localStorage.getItem('sessionId');
        const url = `${environment.apiURL}/admin/devices/search`;
        const headers = new HttpHeaders().set('cookie-header' , `${sessionId}:${this.userName}`);
        return this.http.post<SearchDeviceSessions>(url, payload, { headers });
    }
}